import React, { useLayoutEffect } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './Content.module.scss';
import { useUIContext } from '../../context/UIContext';
import { useMedia } from '../../../common/hooks/useMedia';

export default function Content(props) {
  const { className, triggerManualAnimation, innerRef, children, style } = props;
  const { miniSidebar, mobileSidebar: showMobileSidebar } = useUIContext();
  const smallScreenView = useMedia({ maxWidth: 900 });
  useLayoutEffect(() => {
    if (showMobileSidebar) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      const originalHtmlStyle = window.getComputedStyle(document.documentElement).overflow;
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = originalStyle;
        document.documentElement.style.overflow = originalHtmlStyle;
      };
    }
    return () => {};
  }, [showMobileSidebar]);

  return (
    <div
      ref={innerRef}
      key={triggerManualAnimation}
      style={style}
      className={cx(styles.content, className, {
        [styles.withMiniSidebar]: miniSidebar,
        [styles.smallScreenView]: smallScreenView,
        [styles.withMobileSidebar]: showMobileSidebar,
      })}
    >
      {children}
    </div>
  );
}

Content.defaultProps = {
  className: '',
  children: null,
};

Content.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
